module.exports = __webpack_public_path__ + "assets/img/account.b960b968.svg";